<template>
	<div>
		<div>
			<div style="font-size:20px;float:left;margin:-40px 0 0 40px;font-weight:600">{{organize_name}}</div>
			<el-button
				style="float: right; height: 40px; margin-top: -40px; margin-right: 40px; background-color: #006E4B; color: #FFFFFF; border: 1px solid #006E4B;"
				@click="Return">返回</el-button>
			<!-- 主体 -->
			<div style="height:750px;background-color:white;margin:75px 40px 0 40px;overflow-x: hidden" class="tabs">
				<el-tabs v-model="activeName" @tab-click="handleClick" type="card">
					<el-tab-pane label="项目工资明细表" name="XmGzmx">
						<el-row>
							<el-row>
								<el-table :header-cell-style="{ background: '#d3eae2', color: '#000000' }"
									:border="true" :row-class-name="tableRowClassName" ref="table" :data="gzmxList"
									show-summary height="650" tooltip-effect="dark" style="width: 100%;"
									@selection-change="handleSelectionChange">
									<el-table-column align="center" label="序号" width="50">
										<template slot-scope="scope_1">{{ scope_1.$index + 1 }}</template>
									</el-table-column>
									<el-table-column prop="post_name" align="center" label="岗位" width="70">
									</el-table-column>
									<el-table-column prop="staff_name" align="center" label="姓名" width="70">
									</el-table-column>
									<el-table-column prop="total_wages" align="center" label="工资总额" width="60">
									</el-table-column>
									<el-table-column prop="base_pay" align="center" label="基本工资" width="60">
									</el-table-column>
									<el-table-column prop="post_salary" align="center" label="岗位工资" width="60">
									</el-table-column>
									<el-table-column prop="daily_wage" align="center" label="日工资" width="60">
									</el-table-column>
									<el-table-column prop="days_attendance" align="center" label="应出勤天数" width="60">
									</el-table-column>
									<el-table-column align="center" label="事假/缺勤">
										<el-table-column prop="absence_days" align="center" label="天数" width="60">
										</el-table-column>
										<el-table-column prop="deduction_absence" align="center" label="扣款" width="60">
										</el-table-column>
									</el-table-column>
									<el-table-column prop="actual_attendance_days" align="center" label="实出勤天数"
										width="60">
									</el-table-column>
									<el-table-column prop="wages" align="center" label="工资额" width="60">
									</el-table-column>
									<el-table-column align="center" label="增补项">
										<el-table-column prop="full_work_attendance" align="center" label="满勤"
											width="60">
										</el-table-column>
										<el-table-column prop="meal_supplement" align="center" label="餐补" width="60">
										</el-table-column>
										<el-table-column prop="overtime" align="center" label="加班时间" width="60">
										</el-table-column>
										<el-table-column prop="overtime_amount" align="center" label="加班金额" width="60">
										</el-table-column>
										<el-table-column prop="substitute" align="center" label="替班" width="60">
										</el-table-column>
										<el-table-column prop="telephone_charges" align="center" label="话费" width="60">
										</el-table-column>
										<el-table-column prop="substitute_salary" align="center" label="代岗工资"
											width="60">
										</el-table-column>
										<el-table-column prop="make_up_for_the_early_stage" align="center" label="弥补前期"
											width="60"></el-table-column>
										<el-table-column prop="reward" align="center" label="奖励" width="60">
										</el-table-column>
										<el-table-column prop="return_of_work_clothes_deposit" align="center"
											label="归还工服押金" width="60"></el-table-column>
										<el-table-column prop="other_plus" align="center" label="其他+" width="60">
										</el-table-column>
									</el-table-column>
									<el-table-column align="center" label="扣款项">
										<el-table-column prop="late_deduction" align="center" label="迟到扣款" width="60">
										</el-table-column>
										<el-table-column prop="penalty_deduction" align="center" label="处罚扣款"
											width="60">
										</el-table-column>
										<el-table-column prop="pay_the_work_clothes_deposit" align="center"
											label="发放工服押金" width="60"></el-table-column>
										<el-table-column prop="other_reduce" align="center" label="其他-" width="60">
										</el-table-column>
									</el-table-column>
									<!-- 	<el-table-column align="center" label="补贴项(职能人员用)">
								<el-table-column prop="car_supplement" align="center" label="车补" width="60">
								</el-table-column>
								<el-table-column prop="overseas_subsidies" align="center" label="驻外补助" width="60">
								</el-table-column>
								<el-table-column prop="other_subsidies" align="center" label="其他补贴" width="60">
								</el-table-column>
								<el-table-column prop="subtotal_of_subsidies_payable" align="center" label="应发补贴小计" width="60"></el-table-column>
								<el-table-column prop="subtotal_of_subsidies_paid" align="center" label="实发补贴小计" width="60"></el-table-column>
							</el-table-column> -->
									<el-table-column prop="wages_payable" align="center" label="应发工资" width="60">
									</el-table-column>
									<el-table-column align="center" label="代扣代缴">
										<el-table-column prop="social_security_deduction" align="center" label="社保扣款"
											width="60"></el-table-column>
										<el-table-column prop="accident_insurance" align="center" label="意外保险"
											width="60">
										</el-table-column>
										<el-table-column prop="accumulation_fund" align="center" label="公积金" width="60">
										</el-table-column>
									</el-table-column>
									<el-table-column prop="before_tax_paid_salary" align="center" label="实发工资(税前)"
										width="60">
									</el-table-column>
									<el-table-column prop="individual_income_tax" align="center" label="个人所得税"
										width="60">
									</el-table-column>
									<el-table-column prop="after_tax_paid_salary" align="center" label="实发工资(税后)"
										width="60">
									</el-table-column>
									<el-table-column prop="receiving_method_name" align="center" label="领取方式"
										width="60">
										<!-- <template slot-scope="scope">
									<el-select v-show="scope.row.show" style="margin-right:10px" v-model="scope.row.receiving_method_name"
									 clearable size="mini">
										<el-option v-for="item in lqList" :key="item.lable" :label="item.label">
										</el-option>
									</el-select>
									<span v-show="!scope.row.show">{{ scope.row.receiving_method_name }}</span>
								</template> -->
									</el-table-column>
									<el-table-column prop="bank_card_number" align="center" label="银行卡号" width="100">
									</el-table-column>
									<el-table-column prop="cardholder_name" align="center" label="持卡人" width="70">
									</el-table-column>
									<el-table-column prop="entry_name" align="center" label="项目名称" width="100">
									</el-table-column>
									<el-table-column prop="id_card" align="center" label="身份证号" width="100">
									</el-table-column>
									<el-table-column prop="telephone_number" align="center" label="电话号" width="100">
									</el-table-column>
									<el-table-column prop="gender" align="center" label="性别" width="60">
									</el-table-column>
								</el-table>
							</el-row>
						</el-row>
					</el-tab-pane>
					<el-tab-pane label="支援工资明细表" name="ZyGzmx">
						<el-row style="margin-top: 1px;">
							<el-row>
								<el-table :header-cell-style="{ background: '#d3eae2', color: '#000000' }"
									:border="true" :row-class-name="tableRowClassName" ref="table" :data="zygzmxList"
									show-summary tooltip-effect="dark" height="650" style="width: 100%;"
									@selection-change="handleSelectionChange">
									<el-table-column align="center" label="序号" width="50">
										<template slot-scope="scope_1">{{ scope_1.$index + 1 }}</template>
									</el-table-column>
									<el-table-column prop="post_name" align="center" label="岗位" width="70">
									</el-table-column>
									<el-table-column prop="staff_name" align="center" label="姓名" width="70">
									</el-table-column>
									<el-table-column prop="total_wages" align="center" label="工资总额" width="60">
									</el-table-column>
									<el-table-column prop="base_pay" align="center" label="基本工资" width="60">
									</el-table-column>
									<el-table-column prop="post_salary" align="center" label="岗位工资" width="60">
									</el-table-column>
									<el-table-column prop="daily_wage" align="center" label="日工资" width="60">
									</el-table-column>
									<el-table-column prop="days_attendance" align="center" label="应出勤天数" width="60">
									</el-table-column>
									<el-table-column align="center" label="事假/缺勤">
										<el-table-column prop="absence_days" align="center" label="天数" width="60">
										</el-table-column>
										<el-table-column prop="deduction_absence" align="center" label="扣款" width="60">
										</el-table-column>
									</el-table-column>
									<el-table-column prop="actual_attendance_days" align="center" label="实出勤天数"
										width="60">
									</el-table-column>
									<el-table-column prop="wages" align="center" label="工资额" width="60">
									</el-table-column>
									<el-table-column align="center" label="增补项">
										<el-table-column prop="full_work_attendance" align="center" label="满勤"
											width="60">
										</el-table-column>
										<el-table-column prop="meal_supplement" align="center" label="餐补" width="60">
										</el-table-column>
										<el-table-column prop="overtime" align="center" label="加班时间" width="60">
										</el-table-column>
										<el-table-column prop="overtime_amount" align="center" label="加班金额" width="60">
										</el-table-column>
										<el-table-column prop="substitute" align="center" label="替班" width="60">
										</el-table-column>
										<el-table-column prop="telephone_charges" align="center" label="话费" width="60">
										</el-table-column>
										<el-table-column prop="substitute_salary" align="center" label="代岗工资"
											width="60">
										</el-table-column>
										<el-table-column prop="make_up_for_the_early_stage" align="center" label="弥补前期"
											width="60"></el-table-column>
										<el-table-column prop="reward" align="center" label="奖励" width="60">
										</el-table-column>
										<el-table-column prop="return_of_work_clothes_deposit" align="center"
											label="归还工服押金" width="60"></el-table-column>
										<el-table-column prop="other_plus" align="center" label="其他+" width="60">
										</el-table-column>
									</el-table-column>
									<el-table-column align="center" label="扣款项">
										<el-table-column prop="late_deduction" align="center" label="迟到扣款" width="60">
										</el-table-column>
										<el-table-column prop="penalty_deduction" align="center" label="处罚扣款"
											width="60">
										</el-table-column>
										<el-table-column prop="pay_the_work_clothes_deposit" align="center"
											label="发放工服押金" width="60"></el-table-column>
										<el-table-column prop="other_reduce" align="center" label="其他-" width="60">
										</el-table-column>
									</el-table-column>
									<!-- 	<el-table-column align="center" label="补贴项(职能人员用)">
												<el-table-column prop="car_supplement" align="center" label="车补" width="60">
												</el-table-column>
												<el-table-column prop="overseas_subsidies" align="center" label="驻外补助" width="60">
												</el-table-column>
												<el-table-column prop="other_subsidies" align="center" label="其他补贴" width="60">
												</el-table-column>
												<el-table-column prop="subtotal_of_subsidies_payable" align="center" label="应发补贴小计" width="60"></el-table-column>
												<el-table-column prop="subtotal_of_subsidies_paid" align="center" label="实发补贴小计" width="60"></el-table-column>
											</el-table-column> -->
									<el-table-column prop="wages_payable" align="center" label="应发工资" width="60">
									</el-table-column>
									<el-table-column align="center" label="代扣代缴">
										<el-table-column prop="social_security_deduction" align="center" label="社保扣款"
											width="60"></el-table-column>
										<el-table-column prop="accident_insurance" align="center" label="意外保险"
											width="60">
										</el-table-column>
										<el-table-column prop="accumulation_fund" align="center" label="公积金" width="60">
										</el-table-column>
									</el-table-column>
									<el-table-column prop="before_tax_paid_salary" align="center" label="实发工资(税前)"
										width="60">
									</el-table-column>
									<el-table-column prop="individual_income_tax" align="center" label="个人所得税"
										width="60">
									</el-table-column>
									<el-table-column prop="after_tax_paid_salary" align="center" label="实发工资(税后)"
										width="60">
									</el-table-column>
									<el-table-column prop="receiving_method_name" align="center" label="领取方式"
										width="60">
										<!-- <template slot-scope="scope">
													<el-select v-show="scope.row.show" style="margin-right:10px" v-model="scope.row.receiving_method_name"
													 clearable size="mini">
														<el-option v-for="item in lqList" :key="item.lable" :label="item.label">
														</el-option>
													</el-select>
													<span v-show="!scope.row.show">{{ scope.row.receiving_method_name }}</span>
												</template> -->
									</el-table-column>
									<el-table-column prop="bank_card_number" align="center" label="银行卡号" width="100">
									</el-table-column>
									<el-table-column prop="cardholder_name" align="center" label="持卡人" width="70">
									</el-table-column>
									<el-table-column prop="entry_name" align="center" label="项目名称" width="100">
									</el-table-column>
									<el-table-column prop="id_card" align="center" label="身份证号" width="100">
									</el-table-column>
									<el-table-column prop="telephone_number" align="center" label="电话号" width="100">
									</el-table-column>
									<el-table-column prop="gender" align="center" label="性别" width="60">
									</el-table-column>
								</el-table>
							</el-row>
						</el-row>
					</el-tab-pane>
				</el-tabs>

				<el-row v-show="is_reviewer_state == 0">
					<el-col style="margin:20px 40%;">
						<el-button type="goon" @click="$refs['examine'].save(id, 1)">同意</el-button>
						<el-button type="addbtn" @click="$refs['examine'].reject(id)">驳回</el-button>
					</el-col>
				</el-row>
				<el-row style="display: flex; justify-content: flex-start;flex-wrap: wrap;margin: 0 20px;">
					<div v-for="(item,index) in inforchilds"
						style="flex:1; width: calc((100% - 20px) / 6);min-width: calc((100% - 20px) / 6);max-width: calc((100% - 20px) / 6);">
						<div style="margin:20px 0 0 0 ;font-size:18px;">{{item.role_name}} : {{item.staff_name}}</div>
					</div>
				</el-row>
			</div>

		</div>
		<examine ref="examine" :spare="spare" :id="id"></examine>
	</div>
</template>

<script>
	import examine from "./OA_examine.vue";
	export default {
		components: {
			examine: examine,
		},
		props: ["gzmxList", "inforchilds", "organize_name","zygzmxList"],
		data() {

			return {
				activeName: "XmGzmx",
				editData: {},
				tableData: [],
				gzmxList: [],
				zygzmxList:[],
			};
		},
		created() {
			console.log(this.inforchilds)
		},
		methods: {
			handleClick(tab, event) {
				console.log(tab, event);
				if (tab.name == 'XmGzmx') {
					this.edit();
				} else {
					this.edit();
				}
			},
			submitForm(formName) {
				this.$refs[formName].validate((valid) => {
					if (valid) {
						alert('submit!');
					} else {
						console.log('error submit!!');
						return false;
					}
				});
			},
			resetForm(formName) {
				this.$refs[formName].resetFields();
			},
			Return() {
				this.activeName =  'XmGzmx';
				this.$parent.close();
			}
		}
	}
</script>

<style>
	.el-form-item.is-required:not(.is-no-asterisk)>.el-form-item__label:before {
		content: '';
	}
	.tabs .el-tabs__header{
		margin: 0px;
	}
	.tabs .el-tabs__item.is-active {
		color: #fff;
		background-color: #006E4B;
	}
	.tabs .el-tabs--card>.el-tabs__header .el-tabs__item.is-active{
		border-bottom-color: none;
	}
	
	.tabs .el-tabs__active-bar {
		background-color: #006E4B;
	}
	
	.tabs .el-tabs__item:hover {
		color: #d3eae2;
	}
	.tabs .el-tabs--card>.el-tabs__header{
		border-bottom: 0px;
	}
</style>



// WEBPACK FOOTER //
// Gzhz_gzmx.vue?123a3cfe